import { useEffect, useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Trans, useTranslation } from "react-i18next";
import addOrganizationConfirmationImg from "../../../assets/images/add-organization-confirmation.png";
import pubSub, { EVENTS } from "../../../config/pubSub";
import { OrganizationsContext } from "../organizations-context";
import { ORGANIZATION_TYPE } from "../organizations.model";

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(1),
  display: "flex",
  justifyContent: "center",
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(0),

  "& strong": {
    marginBottom: theme.spacing(1),
  },

  "& img": {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  "& > p, span, img ": {
    paddingTop: "16px",
  },
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  paddingBottom: theme.spacing(3),

  "& button": {
    textTransform: "none",
    width: "100px",
    marginRight: theme.spacing(2),

    "&.MuiButton-containedPrimary": {
      backgroundColor: "var(--kyocera-blue)",
      color: "var(--kyocera-white)",
    },
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 3),
  wordBreak: "break-word",
  paddingBottom: "1vw",
  paddingLeft: "4vw",
  paddingRight: "4vw",
  borderRadius: "10px",
}));

const ConfirmationStep = (props: { open: boolean; handleConfirmClose: () => void }) => {
  const [organization, setOrganization] = useState({
    adminEmail: "",
    type: 0,
    name: "",
  });
  const { setSelectedOrg } = useContext(OrganizationsContext);
  const { t } = useTranslation();

  useEffect(() => {
    pubSub.subscribe(EVENTS.ADD_ORGANIZATION, (org: any) => setOrganization(org));
  }, []);

  const handleConfirm = () => {
    props.handleConfirmClose();
    if (organization.type !== ORGANIZATION_TYPE.Provider) {
      setSelectedOrg(organization.name);
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.handleConfirmClose}
      aria-labelledby="add-organization-dialog"
    >
      <StyledBox>
        <StyledDialogTitle id="add-organization-dialog-title">
          <span style={{ fontSize: "18pt", fontWeight: "bolder" }}>
            {t("cmp_organization_confirm_title")}
          </span>
        </StyledDialogTitle>
        <StyledDialogContent>
          <img
            alt="Add organization confirmation"
            src={addOrganizationConfirmationImg}
            style={{ maxWidth: "70%", height: "auto" }}
          />
          <span style={{ fontSize: "16pt", fontWeight: "bolder" }}>
            {t("cmp_organization_confirm_hurray_title")}
          </span>
          <p style={{ padding: "16px" }}>
            {t("cmp_organization_confirm_label1", {
              email: organization.adminEmail,
            })}
            <br />
            <br />
            {organization.type === ORGANIZATION_TYPE.Customer && (
              <Trans
                i18nKey="cmp_organization_confirm_reminder"
                components={{ strong: <strong /> }}
              />
            )}
          </p>
        </StyledDialogContent>
        <StyledDialogActions>
          <Button variant="contained" onClick={handleConfirm} color="primary">
            {t("common_ok")}
          </Button>
        </StyledDialogActions>
      </StyledBox>
    </Dialog>
  );
};

export default ConfirmationStep;
